import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-atlas-trein-soon',
  templateUrl: './atlas-trein-soon.component.html',
  styleUrls: ['./atlas-trein-soon.component.scss']
})
export class AtlasTreinSoonComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
